import React, { FC } from 'react'
import { Box, Stack, Typography } from '@mui/material'
import DashboardIcon from '@mui/icons-material/Dashboard'
import { PageScaffold } from '@/apps/latest/components/portal/notion'

export const PortalHomePage: FC = () => {
  return (
    <PageScaffold title="管理ポータル">
      <Stack
        alignItems="center"
        justifyContent="center"
        gap={2}
        sx={{ py: 12 }}
      >
        <Box
          sx={{
            color: 'text.disabled',
            '& > svg': { fontSize: 56 },
          }}
        >
          <DashboardIcon />
        </Box>
        <Typography sx={{ fontSize: 14, color: 'text.secondary' }}>
          左側のメニューから機能を選択してください
        </Typography>
      </Stack>
    </PageScaffold>
  )
}
